import guestList from "./guest-list";
import hasRental_prop_persons from "./has-rental_prop_persons";
import showGuestList from "./show-guest-list";

export default function(formLoaded) {
    const quantity = hasRental_prop_persons();
    if (!quantity) {
        return;
    }
    quantity.setAttribute('readonly', true);

    const rentalPropGuestList_1 = document.querySelector("#rental_prop_Guest_List_1");
    const observerOptions = {
        childList: false,
        attributes: true,
        subtree: false
    };

    const observer = new MutationObserver(function(mutationList, observer) {
        if (rentalPropGuestList_1.style.display == 'block') {
            guestList.handleEmptyGuestList();
            if (guestList.hasGuests === false) {
                rentalPropGuestList_1.style.display = 'none';
                rentalPropGuestList_1.classList.remove('guest-list__hidden');
            }
        }
    });
    observer.observe(rentalPropGuestList_1, observerOptions);

    guestList.setFormType(formLoaded);
    guestList.refresh();
    guestList.handleEmptyGuestList();
    guestList.guestListUpdated();

//     <a href="{{ route('register') }}" class="main-header__desktop-link main-header__sign-up-link wi-btn">
//     Sign Up
//     <img src="/img/blue-arrow.svg" alt="" />
// </a>

    const buttonElement = document.createElement('button');
    buttonElement.innerHTML = 'Add Guests';
    buttonElement.setAttribute('type', 'button');
    buttonElement.classList.add('wi-btn');

    const buttonArrowElement = document.createElement('img');
    buttonArrowElement.setAttribute('src', '/img/blue-arrow.svg');
    buttonArrowElement.setAttribute('alt', '');
    buttonElement.append(buttonArrowElement);
    buttonElement.addEventListener('click', function($event) {
        showGuestList();
    });

    const quantityRowElement = quantity.parentNode.parentNode;
    quantityRowElement.classList.add('cnaq-reserve-form__row');

    quantity.parentNode.parentNode.append(buttonElement);
}